import { render, staticRenderFns } from "./UserInfoPromptModalSection.vue?vue&type=template&id=3abc0371&scoped=true"
import script from "./UserInfoPromptModalSection.vue?vue&type=script&lang=ts"
export * from "./UserInfoPromptModalSection.vue?vue&type=script&lang=ts"
import style0 from "./UserInfoPromptModalSection.vue?vue&type=style&index=0&id=3abc0371&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc0371",
  null
  
)

export default component.exports